import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

const STORAGE_KEY = "kredamontiva_cookie_consent_v1";

const grantAll = () => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted",
  });
};

const denyAll = () => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
  });
};

const CookieBanner = () => {
  const { t, lang } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        setVisible(true);
      } else if (stored === "granted") {
        grantAll();
      } else if (stored === "denied") {
        denyAll();
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const persist = (value) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      // ignore
    }
  };

  if (!visible) return null;

  const handleAccept = () => {
    persist("granted");
    grantAll();
    setVisible(false);
  };

  const handleReject = () => {
    persist("denied");
    denyAll();
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={t("cookieBanner.title")}
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-[#0b224a] bg-white shadow-[0_-8px_24px_rgba(15,44,89,0.15)]"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-5 py-5 lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <div className="max-w-3xl">
          <p className="font-serif text-lg font-semibold text-[#0F2C59]">
            {t("cookieBanner.title")}
          </p>
          <p className="mt-1 text-sm text-[#475569]">
            {t("cookieBanner.text")}{" "}
            <NavLink
              to={`/${lang}/cookies`}
              className="font-semibold text-[#0D7A5F] underline underline-offset-2"
              data-testid="cookie-banner-learn-more"
            >
              {t("cookieBanner.learnMore")}
            </NavLink>
          </p>
        </div>
        <div className="flex flex-shrink-0 flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={handleReject}
            className="rounded-md border border-[#0F2C59] px-4 py-2 text-sm font-semibold text-[#0F2C59] hover:bg-[#0F2C59]/5"
            data-testid="cookie-banner-reject"
          >
            {t("cookieBanner.reject")}
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="rounded-md bg-[#0D7A5F] px-4 py-2 text-sm font-semibold text-white hover:bg-[#0B6B53]"
            data-testid="cookie-banner-accept"
          >
            {t("cookieBanner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
